import React from 'react';
/* props:
	type (required string)
	title (required string)
	onSubmit (required function)
	onCancel (required function)
	hide (required boolean)
	input_field_val (required numeric)
*/
class SGValueOverlay extends React.Component {

	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.onAmountChange = this.onAmountChange.bind(this);
		this.hideSelf = this.hideSelf.bind(this);

		this.state = {

			inputFieldVal : 'hidden'
		};

	}

	onSubmit(e) {
		var values = {};

		//get values here and send them back to parent

		this.props.onSubmit(values);
	}

	onAmountChange(e) {
		this.setState({

			inputFieldVal : e.currentTarget.value
		});
	}

	hideSelf() {
		this.props.onCancel();
	}

	render() {

		var hideClass = (this.props.hide) ? 'Hidden' : 'Visible';
		var content = [];

		if(hideClass === 'Visible') {
			var fieldVal = this.state.inputFieldVal;
			if(this.state.inputFieldVal === 'hidden') {
				fieldVal = this.props.input_field_val;
			}
			//INPUT FIELD
			const placeholder = (this.props.type ===  'users') ? 'User count goal' : 'Long-term user goal';
			var field = (
				<div key={'FieldVal'} className="SG-Value-Input-Field">
					<input id='input-field' name='SG-Value-Overlay' type="number" placeholder={placeholder} value={fieldVal} onChange={this.onAmountChange} />
					<span>Users</span>
				</div>
				);
			content.push(field);

			var selectorContent = [];
			//QUARTER SELECTOR
			var quarters = ['Q1', 'Q2', 'Q3', 'Q4'],
				qSelectorContent = [];

			for(var q = 0; q !== quarters.length; q++) {
				qSelectorContent.push((<option key={'Q' + q}>{quarters[q]}</option>));
			}
			var quarterSelector = (
				<div key={'Q Selector'} className="SG-Value-Overlay-QSelect-Block">
					<select id='q-selector' defaultValue={this.props.q_val}>
						{qSelectorContent}
					</select>
				</div>
				);
			selectorContent.push(quarterSelector);

			//YEAR SELECTOR
			var yearOptions = [], 
				currentYear = new Date();

			if (this.props.type === 'program') { 
				currentYear.setFullYear(currentYear.getFullYear() + 2) 
			}

			currentYear = currentYear.getFullYear();

			for(var y = 0; y !== 20; y++) {
				yearOptions.push((<option key={'Y' + y}>{currentYear + y}</option>));
			}
			var yearSelector  = (
				<div key={'Y Selector'} className="SG-Value-Overlay-YearSelect-Block" defaultValue={this.props.y_val}>
					<select id='year-selector'>
						{yearOptions}
					</select>
				</div>
				);
			selectorContent.push(yearSelector);

			content.push((
				<div key={'Selectors'} className="SG-Value-Overlay-Selectors">
					{selectorContent}
				</div>
			));
		}

		return (
			<div className={"SG-Value-Overlay-Layer " + hideClass}>
				<div className="SG-Value-Overlay-Modal">
					<div className="SG-Value-Overlay-Header">
						<div className="SG-Value-Overlay-Title">
							{this.props.title}
						</div>
					</div>
					<div className="SG-Value-Overlay-Content">
						{content}
					</div>
					<div className="SG-Value-Overlay-Footer">
						<div className="SG-Value-Overlay-Cancel">
							<button onClick={this.hideSelf} >Cancel</button>
						</div>
						<div className="SG-Value-Overlay-Save">
							<button onClick={this.onSubmit} >Save</button>
						</div>
					</div>
				</div>
			</div>
			);
	}
}

export default SGValueOverlay;